module.exports = __webpack_public_path__ + "static/media/applenav-ipad.1e1c5bb9.PNG";